// extracted by mini-css-extract-plugin
export default {"customRangePicker":"pure-date-range_customRangePicker__ET7ft"};